import React, { useMemo } from 'react';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef } from '@mui/x-data-grid-pro';
import { generateGlobalColumns, IDataGridConfig } from '@ts/storybook';
import { IConfigComponent, CKPIReport } from '@ts/ui-models';

interface IKPIReportsProps {
  configComponent?: IConfigComponent;
  inheritedProps?: any;
}

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'kpiReports',
  aclId: 'KpiRepDef',
  entity: 'kpiReport',
  fetchURL: '/api/kpiReports',
  crudURL: '/api/kpiReport',
  mainClass: CKPIReport,
};

const KPIReports = (props: IKPIReportsProps) => {
  const { configComponent = defaultConfigComponent } = props;
  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
  };

  const getColumns = useMemo((): GridColDef<any>[] => {
    const mixProps = { ...props, configComponent };
    const globalCells = generateGlobalColumns(mixProps);
    return [globalCells.id(), globalCells.name()];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      //Extra data
      inheritedProps={props.inheritedProps}
    />
  );
};

export default KPIReports;
